import React from 'react';
import { Box, LinearProgress } from '@mui/material';
import { useDelayedVisible } from '../hooks/useDelayedVisible';

/** Shown while a page chunk or the session loads: nothing for fast loads, then a thin progress bar. */
const RouteLoadingFallback: React.FC = () => {
  const visible = useDelayedVisible();
  return (
    <Box role="status" aria-label="Loading page" sx={{ minHeight: 240 }}>
      {visible && <LinearProgress />}
    </Box>
  );
};

export default RouteLoadingFallback;
